import { Controller } from "@hotwired/stimulus"
import lottie from "lottie-web"

export default class extends Controller {
  static values = {
    path: String,
  }

  connect() {
    this.animation = lottie.loadAnimation({
      container: this.element,
      renderer: "svg",
      loop: false,
      autoplay: true,
      path: this.pathValue,
    })
    this.animation.onComplete = () => {
      this.element.dataset.completed = "true"
      this.dispatch("complete")
    }
    // onEnterFrame: () => {
    //   console.log("onEnterFrame")
    //   this.dispatch("enterFrame")
    // },
    // onSegmentStart: () => {
    //   console.log("onSegmentStart")
    //   this.dispatch("segmentStart")
    // },
  }

  disconnect() {
    this.animation.destroy()
  }
}
